import { Link } from "react-router-dom";
import { formatGBP } from "@/lib/api";

export default function ProductCard({ product }) {
  const out = product.stock <= 0;
  return (
    <Link
      to={`/product/${product.slug}`}
      className="group block hover-zoom"
      data-testid={`product-card-${product.product_id}`}
    >
      <div className="overflow-hidden bg-[#FDF1EC] relative aspect-[4/5]">
        {product.featured && !out && (
          <span className="absolute top-4 left-4 bg-[#831132] text-[#FFF4E0] text-[10px] uppercase tracking-[0.22em] px-3 py-1 z-10">
            Bestseller
          </span>
        )}
        {out && (
          <span className="absolute top-4 left-4 bg-[#1A0F11] text-[#FFF4E0] text-[10px] uppercase tracking-[0.22em] px-3 py-1 z-10">
            Sold out
          </span>
        )}
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="pt-4">
        <h3 className="font-serif-display text-xl text-[#1A0F11] leading-tight group-hover:text-[#831132] transition-colors">
          {product.name}
        </h3>
        <div className="text-xs text-[#5C4A4D] mt-1 uppercase tracking-[0.18em]">
          {product.length || (product.colors?.length ? `${product.colors.length} colours` : "Crown collection")}
        </div>
        <div className="mt-2 text-[#1A0F11] font-medium">{formatGBP(product.price)}</div>
      </div>
    </Link>
  );
}
